module.exports = __webpack_public_path__ + "static/media/forgot-password.4ad52539.svg";